import { useEffect, useState } from 'react'
import { Container, Row, Col, Input, Label } from 'reactstrap'
import { GoogleAutocomplete } from 'components/ideal-core-ui'
import { timezoneDate, utcDate } from 'utils/helpers'
import { getDateFormat } from 'utils/authService'
import DatePicker from 'react-datepicker'
import '!style-loader!css-loader!react-datepicker/dist/react-datepicker.css' // eslint-disable-line
import moment from 'moment'
import s from './LeadForm.scss'
import { useSelector } from 'react-redux'
import { toUsers, toSelectItems, toLeadOwner } from './serializers'
import { makeGetRequest, makeLeadsGetRequest } from 'utils/api'
import Select from 'react-select'

const LeadForm = ({ lead, setLead }) => {
  const storedUsers = useSelector(state => state.users.users)
  const [users, setUsers] = useState(toUsers(storedUsers) || [])
  const [statuses, setStatuses] = useState([])
  const [sources, setSources] = useState([])
  const [states, setStates] = useState([])
  const [tags, setTags] = useState([])

  useEffect(() => {
    ;(async () => {
      const responseStauses = await makeLeadsGetRequest('/v1/status')
      setStatuses(toSelectItems(responseStauses))

      const responseSources = await makeLeadsGetRequest('/v1/source')
      setSources(toSelectItems(responseSources))

      const responseStates = await makeLeadsGetRequest('/v1/state')
      setStates(toSelectItems(responseStates))

      const responseTags = await makeLeadsGetRequest('/v1/tag')
      setTags(toSelectItems(responseTags))

      if (users.length) return
      const { content } = await makeGetRequest('/v1/users')
      setUsers(toUsers(content))
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const changeProperty = (value, property) => {
    setLead(draft => {
      draft[property] = value
    })
  }

  const onSelectCallback = params => {
    const { address, city, state, zipCode, country, street } = params
    setLead(draft => {
      draft.address = address
      draft.city = city
      draft.region = state
      draft.zipCode = zipCode
      draft.country = country
      draft.address2 = street
    })
  }

  return (
    <Container>
      <Row>
        <div className={s.fieldWrapper}>
          <Label className={s.formLabel} for="name">
            Lead Name *
          </Label>
          <Input
            type="text"
            onChange={value => changeProperty(value.target.value, 'name')}
            value={lead.name}
            name="name"
            placeholder="Type in"
            tabIndex="1"
          />
        </div>
      </Row>
      <Row>
        <Col className={s.colForm} lg="6">
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="contactFirstName">
              Lead Contact First Name
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'contactFirstName')}
              value={lead.contactFirstName}
              name="contactFirstName"
              placeholder="Type in"
              tabIndex="2"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="email">
              Lead Contact Email
            </Label>
            <Input
              type="email"
              onChange={value => changeProperty(value.target.value, 'email')}
              value={lead.email}
              name="email"
              placeholder="Type in"
              tabIndex="4"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="mobilePhone">
              Lead Contact Mobile Phone
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'mobilePhone')}
              value={lead.mobilePhone}
              name="mobilePhone"
              placeholder="Type in"
              tabIndex="7"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="company">
              Lead Contact Company
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'company')}
              value={lead.company}
              name="company"
              placeholder="Type in"
              tabIndex="6"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="website">
              Lead Website
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'website')}
              value={lead.website}
              name="website"
              placeholder="Type in"
              tabIndex="18"
            />
          </div>
        </Col>
        <Col className={s.colForm} lg="6">
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="contactLastName">
              Lead Contact Last Name
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'contactLastName')}
              value={lead.contactLastName}
              name="contactLastName"
              placeholder="Type in"
              tabIndex="3"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="phone">
              Lead Contact Phone
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'phone')}
              value={lead.phone}
              name="phone"
              placeholder="Type in"
              tabIndex="5"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="officePhone">
              Lead Contact Office Phone
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'officePhone')}
              value={lead.officePhone}
              name="officePhone"
              placeholder="Type in"
              tabIndex="15"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="title">
              Lead Contact Title
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'title')}
              value={lead.title}
              name="title"
              placeholder="Type in"
              tabIndex="7"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <div className={s.fieldWrapper}>
          <Label className={s.formLabel} for="address">
            Address
          </Label>
          <GoogleAutocomplete
            className={s.googleAutocomplete}
            value={lead.address}
            name="address"
            onChange={value => changeProperty(value, 'address')}
            onSelectCallback={onSelectCallback}
            tabIndex="8"
          />
        </div>
      </Row>
      <Row>
        <Col className={s.colForm} lg="6">
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="address2">
              Address 1
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'address2')}
              value={lead.address2}
              name="address2"
              placeholder="Type in"
              tabIndex="9"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="city">
              City
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'city')}
              value={lead.city}
              name="city"
              placeholder="Type in"
              tabIndex="11"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="zipCode">
              ZIP / Postal Code
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'zipCode')}
              value={lead.zipCode}
              name="zipCode"
              placeholder="Type in"
              tabIndex="13"
            />
          </div>
        </Col>
        <Col className={s.colForm} lg="6">
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="street2">
              Address 2
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'street2')}
              value={lead.street2}
              name="street2"
              placeholder="Type in"
              tabIndex="10"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="region">
              State / Province / Region
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'region')}
              value={lead.region}
              name="region"
              placeholder="Type in"
              tabIndex="12"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="country">
              Country
            </Label>
            <Input
              type="text"
              onChange={value => changeProperty(value.target.value, 'country')}
              value={lead.country}
              name="country"
              placeholder="Type in"
              tabIndex="14"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col className={s.colForm} lg="6">
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="status">
              Lead Status
            </Label>
            <Select
              onChange={value => changeProperty(value, 'status')}
              options={statuses}
              placeholder="Select Status"
              value={lead.status}
              tabIndex="15"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="state">
              Lead State
            </Label>
            <Select
              onChange={value => changeProperty(value, 'state')}
              options={states}
              placeholder="Select State"
              value={lead.state}
              tabIndex="17"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="followUpDate">
              Follow-up Date
            </Label>
            <DatePicker
              selected={
                lead.followUpDate
                  ? moment(
                      timezoneDate(lead.followUpDate, 'HH:mm:ss'),
                      `${getDateFormat()} HH:mm:ss`
                    ).toDate()
                  : ''
              }
              startDate={moment(
                timezoneDate(lead.followUpDate, 'HH:mm:ss'),
                `${getDateFormat()} HH:mm:ss`
              ).toDate()}
              onChange={value => {
                if (!value) return
                changeProperty(utcDate(value), 'followUpDate')
              }}
              showTimeSelect
              timeFormat="h:mm aa"
              timeIntervals={15}
              dateFormat={`${getDateFormat().replace('YYYY', 'yyyy').replace('DD', 'dd')} h:mm aa`}
              timeCaption="time"
              placeholderText="Select lead follow-up date"
              className={s.followUpDate}
              tabIndex="19"
            />
          </div>
        </Col>
        <Col className={s.colForm} lg="6">
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="source">
              Lead Source
            </Label>
            <Select
              onChange={value => changeProperty(value, 'source')}
              options={sources}
              placeholder="Select Source"
              value={lead.source}
              tabIndex="16"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="owner">
              Lead Owner
            </Label>
            <Select
              onChange={value => changeProperty(value, 'owner')}
              options={users}
              value={toLeadOwner(lead.owner, users)}
              placeholder="Select User(s)"
              className={s.userSelect}
              tabIndex="18"
            />
          </div>
          <div className={s.fieldWrapper}>
            <Label className={s.formLabel} for="tags">
              Lead Tags
            </Label>
            <Select
              onChange={value => changeProperty(value, 'tags')}
              options={tags}
              placeholder="Select Tags"
              value={lead.tags}
              isMulti
              tabIndex="20"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <div className={s.fieldWrapper}>
          <Label className={s.formLabel} for="about">
            About
          </Label>
          <Input
            type="textarea"
            rows="5"
            onChange={value => changeProperty(value.target.value, 'about')}
            value={lead.about}
            name="about"
            placeholder="Type in"
            tabIndex="21"
          />
        </div>
      </Row>
    </Container>
  )
}

export default LeadForm
